import { styled } from '@mui/material/styles';
import { Box, Button, Input, Typography } from '@mui/material';
import { keyframes } from '@mui/system';

// Keyframes definition
const cloudyFadeOutLeft = keyframes`
  0% {
    opacity: 1;
    filter: blur(0);
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    filter: blur(10px);
  }
`;

// Styled components
export const StyledContainer = styled(Box)({
  width: '100%',
  left: '50%',
  padding: '10px 16px',
  height: 'var(--app-height)',
  minHeight: '550px',
});

export const ProgressBar = styled(Box)<{ $fadeOut?: boolean }>(({ $fadeOut }) => ({
  width: '100%',
  height: '86px',
  margin: '0 auto',
  ...($fadeOut && {
    animation: `${cloudyFadeOutLeft} 1.5s ease-out forwards`,
    opacity: 1,
  }),
}));

export const StyledForm = styled('form')(({ theme }) => ({
  width: '100%',
  minWidth: '290px',
  padding: '16px',
  borderRadius: '8px',
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(255, 255, 255, 0.4)',
  border: `1px solid ${theme.palette.primary.main}`,
  height: '238px',
}));

export const AuthSubmitBtn = styled(Button)(({ theme }) => ({
  marginTop: '12px',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  width: '100%',
  height: '12.2vw',
  maxHeight: '52px',
  fontSize: 'clamp(16px, 4.4vw, 24px)',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'unset',
  },
}));

export const StyledTextField = styled(Box)({
  background: 'white !important',
  '& .MuiFormLabel-root': {
    fontSize: '24px !important',
    fontWeight: 700,
    letterSpacing: '0.15px',
    color: '#475467 !important',
  },
  '& input': {
    background: 'white !important',
    paddingLeft: '0',
    fontSize: '16px',
    color: '#2D11AD !important',
    '&::placeholder': {
      background: 'white !important',
      opacity: '1 !important',
      color: '#2D11AD !important',
    },
    '& .react-tel-input': {
      backgroundColor: 'white !important',
    },
    '& .form-control': {
      backgroundColor: 'white !important',
    },
  },
});

export const NameText = styled(Typography)({
  color: '#344054',
  fontWeight: '600',
  width: '81.9vw',
  maxWidth: '442px',
  fontSize: 'clamp(18px, 5vw, 27px)',
  marginBottom: '7px',
});

export const FormLabel = styled(Typography)({
  color: '#475467',
  fontSize: '18px',
  fontWeight: 400,
  margin: '16px 8px',
});

export const StyledInput = styled(Input)({
  width: '100%',
  height: '12.2vw',
  maxHeight: '52px',
  border: '1px solid',
  borderRadius: '8px',
  borderColor: '#D0D5DD',
  marginBottom: '10px',
  background: 'white',
  paddingLeft: '12px',
  color: '#2D11AD',
  '& .MuiInput-input:-webkit-autofill, .MuiInput-input:-webkit-autofill:focus, .MuiInput-input:-webkit-autofill:hover':
    {
      WebkitTextFillColor: '#2D11AD',
      fontSize: 'clamp(16px, 4.4vw, 24px)',
    },
  '& input': {
    color: '#2D11AD !important',
    fontSize: 'clamp(16px, 4.4vw, 24px)',
    '&::placeholder': {
      color: '#A9B3C8',
    },
  },
  '&.Mui-error': {
    borderColor: '#ED2E38',
  },
});

export const ErrorText = styled(Typography)({
  fontSize: 'clamp(11px, 3.05vw, 16.5px )',
  color: '#ED2E38',
  width: '81.9vw',
  maxWidth: '442px',
  marginTop: '-8px',
  marginBottom: '10px',
  letterSpacing: '0.11px',
});

export const DontCloseText = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  color: theme.palette.common.white,
  marginTop: '42px',
  fontSize: '15px',
  fontWeight: '500',
}));

export const MessageRateText = styled(Typography)({
  fontSize: 'clamp(14px, 3.9vw, 21px)',
  fontWeight: 400,
  textAlign: 'center',
  paddingTop: '10px',
});

export const MessageRateLabel = styled(Typography)({
  fontSize: 'clamp(12px, 3.15vw, 16px)',
  fontWeight: 400,
  textAlign: 'center',
  paddingTop: '6px',
  color: 'var(--lightBlack)',
});

export const CaptchaWrapper = styled(Box)({
  overflow: 'hidden',
  position: 'absolute',
  bottom: '20px',
  left: '0px',
  height: '100px',
  width: '70px',
  '& .grecaptcha-badge': {
    position: 'absolute !important',
    bottom: '15px !important',
    left: '0px',
  },
});
